const storeDetailsEvent = ({ interaction, store }) => ({
  event: "storeDetailsClick",
  storeLocator: {
    action: {
      step: "store locator details",
      interaction
    },
    store: {
      id: store.globalStoreId,
      name: store.name,
      city: store.town,
      country: store.country,
      address: `${store.streetName}${store.streetNumber ? ` ${store.streetNumber}` : ""}${store.additionalStreetInfo ? ` ${store.additionalStreetInfo}` : ""}, ${store.town}`,
      postalCode: store.postalCode ?? ""
    }
  }
});
const storeGroupEvent = ({ interaction, store, step, city }) => ({
  event: "storeGroupClick",
  storeLocator: {
    action: {
      step,
      interaction,
      ...city === void 0 ? {} : { city }
    },
    ...store === void 0 ? {} : {
      store: {
        id: String(store.globalStoreId),
        name: store.name,
        city: store.town,
        country: store.country,
        address: `${store.streetName}${store.streetNumber ? ` ${store.streetNumber}` : ""}${store.additionalStreetInfo ? ` ${store.additionalStreetInfo}` : ""}, ${store.town}`,
        postalCode: store.postalCode ?? ""
      }
    }
  }
});
const storesLocatorResultEvent = ({
  interaction,
  searchResults,
  searchPosition,
  store,
  preferredStore
}) => ({
  event: "storeSearchResults",
  storeLocator: {
    action: {
      step: "store locator results",
      interaction,
      ...searchResults === void 0 ? {} : { searchResults },
      ...searchPosition === void 0 ? {} : { searchPosition }
    },
    store: {
      id: String(store.globalStoreId),
      name: store.name,
      city: store.town,
      country: store.country,
      address: `${store.streetName}${store.streetNumber ? ` ${store.streetNumber}` : ""}${store.additionalStreetInfo ? ` ${store.additionalStreetInfo}` : ""}, ${store.town}`,
      postalCode: store.postalCode ?? "",
      preferredStore: preferredStore ?? false
    }
  }
});
const storeSearchSubmitEvent = ({
  interaction,
  searchResults,
  location
}) => ({
  event: "storeSearchSubmit",
  storeLocator: {
    action: {
      step: "store locator search",
      interaction,
      location,
      searchResults
    }
  }
});
const storesSearchFilterEvent = ({
  activeFilters,
  searchResults
}) => ({
  event: "storeSearchFilter",
  storeLocator: {
    action: {
      step: "store filter",
      interaction: "filter click",
      filterName: activeFilters.join(", "),
      searchResults: searchResults ?? null
    }
  }
});
export {
  storeDetailsEvent,
  storeGroupEvent,
  storeSearchSubmitEvent,
  storesLocatorResultEvent,
  storesSearchFilterEvent
};
//# sourceMappingURL=actions.js.map
